import { createContext } from "react";

const empresasContext = createContext();

export default empresasContext;
